import { Link } from "@tanstack/react-router"

import type { Issue } from "@productlane/zero"
import { cn } from "@productlane/lib/src/cn"
import { formatRelativeTime } from "@productlane/lib/src/date"
import { IssueStatusIcon } from "@productlane/ui"

import { useDetailLinkProps } from "@/lib/detail-drawer"
import { IssuePriorityIcon } from "@/screens/app/issues/issue-priority-icon"

interface Props {
	className?: string
	issue: Issue
}

export const IssueTableItem = ({ issue, className }: Props) => {
	const linkProps = useDetailLinkProps("issue", issue.id)
	return (
		<Link {...linkProps}>
			<div
				className={cn(
					"flex w-full flex-row items-center gap-3 px-6 py-2.5 hover:bg-gray-50 dark:hover:bg-gray-850",
					className,
				)}
			>
				<IssueStatusIcon
					status={issue.status ?? ""}
					color={issue.statusColor ?? ""}
					className="h-3.5 w-3.5 flex-none"
				/>
				<IssuePriorityIcon
					className="hidden h-4 w-4 flex-none md:block"
					priority={issue.priority}
				/>
				<div className="hidden w-auto flex-none text-xs font-normal tabular-nums text-gray-500 md:block">
					{issue.identifier}
				</div>
				<div className="flex-1 truncate text-sm font-medium">{issue.title}</div>
				<div className="ml-auto text-xs font-normal text-gray-500">
					{formatRelativeTime(new Date(issue?.updatedAt ?? issue.createdAt))}
				</div>
			</div>
		</Link>
	)
}
